import React, { useEffect, useState } from 'react';
import MealCategoryCard from 'components/meal-category-card';
import { MealCategoryType } from 'utils/types';
import PageText from 'components/base/page-text';
import useDashboardContext from 'contexts/dashboard.context';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import SearchNav from 'components/search-nav';
import DeleteModal from 'components/base/delete-modal';

const TrashedMealCategories = () => {
  const { category, activeCokitchen } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [activeCategory, setActiveCategory] = useState({} as MealCategoryType);
  const [showRestoreCategoryModal, setShowRestoreCategoryModal] = useState(false);
  const [categoryList, setCategoryList] = useState([] as MealCategoryType[]);
  const [selectedItems, setSelectedItems] = useState([] as string[]);

  const fetchData = async () => {
    setLoading(true);
    const payload = { type: 'meal_category', cokitchen_id: activeCokitchen?.id };
    try {
      const res: any = await apiService.post('marketing/get-archived-items', { data: payload });
      const response = res?.data?.data;
      if (response) {
        setCategoryList(res?.data?.data.reverse());
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [activeCokitchen?.id]);

  const handleRestoreClick = async () => {
    setLoading(true);
    const itemIds = selectedItems.length > 0 ? selectedItems : [activeCategory.id];
    const payload = { type: 'meal_category', item_ids: itemIds };
    try {
      const res: any = await apiService.post('marketing/restore-bulk-items', { data: payload });
      if (res.data) {
        setSelectedItems([]);
        restoreModal();
        toast(
          <ToastMessage
            type='success'
            message={`Restored ${activeCategory.name || 'items'} successfully `}
          />
        );
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      fetchData();
      setLoading(false);
    }
  };

  const restoreModal = () => {
    setShowRestoreCategoryModal(!showRestoreCategoryModal);
  };
  const removeAll = () => {
    setSelectedItems([]);
  };
  const handleSelectAll = () => {
    const allIds: string[] = categoryList?.map((item: any) => item.id);
    setSelectedItems(allIds);
  };

  const handleChange = (category: MealCategoryType) => {
    const resultExists = selectedItems.find((id) => id === category.id);
    if (resultExists) {
      setSelectedItems(selectedItems.filter((id) => id !== category.id));
    } else {
      setSelectedItems([...selectedItems, category.id]);
    }
  };

  return (
    <div>
      {loading ? (
        <PageText text='Loading...' />
      ) : category.length === 0 && !loading ? (
        <PageText text='No meal category found' />
      ) : (
        <div className='grid md:grid-cols-2 gap-4 items-center flex-wrap'>
          {categoryList.map((item, index) => (
            <div key={index} onClick={() => setActiveCategory(item)}>
              <MealCategoryCard
                selectedItems={selectedItems}
                data={item}
                onChange={() => {
                  handleChange(item);
                  setActiveCategory({} as MealCategoryType);
                }}
                onRestoreComplete={fetchData}
              />
            </div>
          ))}
        </div>
      )}
      {selectedItems.length > 0 && (
        <SearchNav
          count={selectedItems.length}
          handleSelectAll={handleSelectAll}
          onRestoreClick={restoreModal}
          onDoneClick={removeAll}
        />
      )}
      <DeleteModal
        show={showRestoreCategoryModal}
        type='restore'
        onClose={restoreModal}
        handleDelete={() => handleRestoreClick()}
        title={`Are you sure you want to restore ${
          selectedItems.length > 0 ? 'items' : activeCategory?.name
        } ?`}
        description='This action will restore this meal category'
        loading={loading}
      />
    </div>
  );
};

export default TrashedMealCategories;
